import { useTranslationInvestor } from '@dealstack/frontend/shared/mechanism/i18n/i18nHooks';
import { InvestorTransactionSummaryRes } from '@dealstack/shared/lib/generated';
import { useMemo } from 'react';
import { BasicMantineTable } from '@dealstack/frontend/shared/components/BasicMantineTable/BasicMantineTable';
import { getTransactionsTableColumns } from './transactionsTableColumns';

interface Props {
	data: InvestorTransactionSummaryRes[];
	isLoading?: boolean;
}

export const InvestorTransactionsTable = ({ data, isLoading }: Props) => {
	const tInvestor = useTranslationInvestor();

	const columns = useMemo(() => getTransactionsTableColumns({ tInvestor }), [tInvestor]);

	return (
		<BasicMantineTable<InvestorTransactionSummaryRes>
			columns={columns}
			data={data}
			isLoading={isLoading}
			hideTopToolbar
		/>
	);
};
